/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
// import PropTypes from 'prop-types'

// Hooks
import { useAppKitProvider } from '@reown/appkit/react'

// Components
import { Button } from 'views/components'

function BitcoinProvider(props) {
  const { messageToSign, setSignature, address, isLoading } = props
  const { walletProvider } = useAppKitProvider('bip122') // Namespace for Bitcoin

  // Functions
  // const isPubkeyValid = async (signature) => {
  //   const pubkey = await walletProvider.getPublicKey({ address })
  //   const isTaproot = address.startsWith('bc1p')

  //   let sigBytes
  //   try {
  //     // Try base64 first
  //     sigBytes = Uint8Array.from(atob(signature), (c) => c.charCodeAt(0))
  //   } catch (e1) {
  //     try {
  //       // Try hex fallback
  //       const hex = signature.toLowerCase().replace(/^0x/, '').trim()
  //       if (/^[0-9a-f]{128}$/i.test(hex)) {
  //         sigBytes = Uint8Array.from(hex.match(/.{1,2}/g).map((b) => parseInt(b, 16)))
  //       } else {
  //         console.error('Invalid signature: not base64 or hex')
  //         setErrMsg(
  //           'Invalid Taproot signature or public key.\n\n' +
  //             'This wallet may not support proper Taproot signing. Try another address type.'
  //         )
  //         return false
  //       }
  //     } catch (e2) {
  //       console.error('Invalid signature: not base64 or hex', { e1, e2 })
  //       setErrMsg(
  //         'Invalid Taproot signature or public key.\n\n' +
  //           'This wallet may not support proper Taproot signing. Try another address type.'
  //       )
  //       return false
  //     }
  //   }

  //   if (isTaproot) {
  //     const isSchnorr = sigBytes.length === 64 && sigBytes[0] !== 0x30 // 0x30 = DER
  //     const isXOnly = pubkey.length === 64 // 32 bytes hex = 64 chars

  //     if (!isSchnorr || !isXOnly) {
  //       setErrMsg(
  //         'Invalid Taproot signature or public key.\n\n' +
  //           'This wallet may not support proper Taproot signing. Try another address type.'
  //       )
  //       return false
  //     }
  //   }
  //   return true
  // }
  const handleSignBtc = async () => {
    try {
      // Bitcoin's signMessage expects an object with address and message
      const signature = await walletProvider.signMessage({
        address,
        message: messageToSign,
      })
      // const validPubkey = await isPubkeyValid()
      // if (!validPubkey) {
      //   return
      // }
      if (setSignature) {
        setSignature(signature)
      }

      // You would typically update your UI with this signature
    } catch (error) {
      console.error('Error signing BTC message:', error)
    }
  }

  return (
    <Button fullWidth type="button" onClick={handleSignBtc} disabled={isLoading}>
      {isLoading ? 'Loading...' : 'Sign BTC Message'}
    </Button>
  )
}

// Default Props
BitcoinProvider.defaultProps = {}

// Proptypes Validation
BitcoinProvider.propTypes = {}

export default BitcoinProvider
